import { connect } from 'react-redux'
import { HubspotLink } from '@components/account/accountSections'

import coordinators from '@coordinators'
import services from '@services'
import presenters from '@presenters'
import { HandleError } from '@coordinators/composed'

const mapDispatchToProps = () => {
  const { RestService, UIService, HubspotCompanyService } = services
  const {
    ChangeHubspotCompany,
    SearchHubspotCompanyById,
    GetHubspotCompanyById,
    CheckCompanyLinked,
  } = coordinators
  const { pResponseFullHubspotCompanies, pResponseFullHubspotCompany } =
    presenters.Api

  const changeHubspotCompany = ChangeHubspotCompany({
    RestService,
    HandleError,
  })

  const searchHubspotCompanyById = SearchHubspotCompanyById({
    RestService,
    HubspotService: HubspotCompanyService,
    pResponseHubspotList: pResponseFullHubspotCompanies,
    endpoint: 'companies',
    HandleError,
  })
  const getHubspotCompanyById = GetHubspotCompanyById({
    RestService,
    pResponseFullHubspotCompany,
    endpoint: 'companies',
    HandleError,
  })

  const checkCompanyLinked = CheckCompanyLinked({
    RestService,
  })

  const {
    InfoModal: {
      displayInfoModal: showChangeCompanyModal,
      dismissInfoModal: dismissChangeCompanyModal,
    },
    FlashMessage: {
      displayFailureMessage: flashError,
      displayWarningMessage: flashWarning,
      displaySuccessMessage: flashSuccess,
    },
  } = UIService

  return {
    showChangeCompanyModal,
    dismissChangeCompanyModal,
    changeHubspotCompany,
    searchHubspotCompanyById,
    getHubspotCompanyById,
    checkCompanyLinked,
    flashError,
    flashSuccess,
    flashWarning,
  }
}

export default connect(undefined, mapDispatchToProps)(HubspotLink)
